function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "shopping-bag_svg__st0",
  d: "M130.6 169.5H16.7c-2.6 0-5.1-1.2-6.7-3.2-1.6-2-2.3-4.6-1.9-7.1L18.6 42.1V42c.8-4.2 4.4-7.2 8.6-7.2h93.1c4.3 0 7.9 3 8.6 7.2v.2l10.2 117c.4 2.5-.3 5.1-1.9 7.1-1.6 2-4 3.2-6.6 3.2zM23.4 42.7L12.9 159.9v.1c-.2 1.2.1 2.3.8 3.2.7.9 1.9 1.4 3 1.4h113.9c1.2 0 2.3-.5 3-1.4.7-.9 1.1-2.1.9-3.2v-.2l-10.2-117c-.4-1.8-2-3.1-3.9-3.1H27.2c-1.8-.1-3.4 1.2-3.8 3zM10.5 159.5z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "shopping-bag_svg__st0",
  d: "M97.1 61.9c-1.3 0-2.4-1.1-2.4-2.4V31.6c0-11.6-9.4-21-21-21s-21 9.4-21 21v27.9c0 1.3-1.1 2.4-2.4 2.4s-2.4-1.1-2.4-2.4V31.6c0-14.3 11.6-25.9 25.9-25.9 14.3 0 25.9 11.6 25.9 25.9v27.9c-.2 1.4-1.3 2.4-2.6 2.4z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  transform: "rotate(-76.809 50.176 59.52)",
  className: "shopping-bag_svg__st0",
  cx: 50.2,
  cy: 59.5,
  r: 5.1
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  transform: "rotate(-45.001 97.107 59.521)",
  className: "shopping-bag_svg__st0",
  cx: 97.1,
  cy: 59.5,
  r: 5.1
});

function SvgShoppingBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.3 178.3"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgShoppingBag;